export default {
  setSiwfData(state, data) {
    state.siwfData = data;
  },
};
